import messages from "messages";

/**
 * return skip message check if treatment plan goals are valid
 */
export default function getGoalsValidationError(arg: AdvancedTreatmentPlan) {
  // no valid goal
  if (!arg?.goals?.[0]?.value) {
    return {
      children: messages.youMustCreateGoal1,
      labelCancel: messages.noCreateGoalNow,
    };
  }

  // no valid objective in a valid goal
  return !arg.goals[0].objectives?.[0]?.value
    ? {
        children: messages.youMustCreateObjective1,
        labelCancel: messages.noCreateObjectiveNow,
      }
    : undefined;
}
